import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=36fdfbd0&scoped=true"
import script from "./assets.vue?vue&type=script&lang=js"
export * from "./assets.vue?vue&type=script&lang=js"
import style0 from "./assets.vue?vue&type=style&index=0&id=36fdfbd0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fdfbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fdfbd0')) {
      api.createRecord('36fdfbd0', component.options)
    } else {
      api.reload('36fdfbd0', component.options)
    }
    module.hot.accept("./assets.vue?vue&type=template&id=36fdfbd0&scoped=true", function () {
      api.rerender('36fdfbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/profile/assets.vue"
export default component.exports